/**
 * Enumeration to map the fetch request names that could be done along the page.
 * It is not intended to execute the requests, but to be able to make any reference about them.
 */
export default class FetchRequest {

  // This result-related call is about the listings that will be shown on the page.
  // This call only returns the HTML related to the listing cards that will be shown.
  static get Listings() {
    return this.getInstance('listings');
  }

  // This result-related call is about the counts on the search.
  // This call returns a JSON with the total result count value.
  static get Counts() {
    return this.getInstance('counts');
  }

  // This result-related call is about the facets information on the search.
  // This call returns a JSON with the values that are used on faceting that changes according to
  // the search.
  static get SchoolsAndBrandsFaceting() {
    return this.getInstance('schoolsAndBrandsFaceting');
  }

  static fromKey(key) {
    const resultsFetchingCallMap = {
      listings: FetchRequest.Listings,
      counts: FetchRequest.Counts,
      schoolsAndBrandsFaceting: FetchRequest.SchoolsAndBrandsFaceting,
    };

    return resultsFetchingCallMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new FetchRequest(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(FetchRequest, 'instances', { value: {} });